/**
 * A TEXTAREA THAT IS AS TALL AS WHAT IS IN IT, up to a ceiling — then it scrolls inside.
 *
 * Owner, 2026-09-20, on the chat composer: "it just goes off the end of the screen and is cut off
 * by the edge of the text box." A single-line field hides the start of a long question; a fixed
 * tall box wastes the row on a short one. This sets `style.height` and nothing else: the VALUE is
 * still the DOM's, so undo (Ctrl+Z) keeps working. `auto` first, because scrollHeight never
 * shrinks on its own. The same move the journal composer makes (mobile/today/Composer.tsx).
 */
export function fitToText(node: HTMLTextAreaElement | null, maxPx: number): void {
  if (!node) return
  node.style.height = 'auto'
  // happy-dom reports 0 here; a real browser reports the text's height. Either way the floor is
  // the one-row height the stylesheet gives it, so 0 collapses to nothing visible.
  const wanted = node.scrollHeight
  node.style.height = wanted > 0 ? `${Math.min(wanted, maxPx)}px` : ''
  node.style.overflowY = wanted > maxPx ? 'auto' : 'hidden'
}

/** Six lines of 14px/1.45 text plus a little; past this the field scrolls. */
export const CHAT_INPUT_MAX_PX = 132
